import Vue, { CreateElement } from 'vue'
import { Component } from 'vue-property-decorator'
import { Caption, Subtitle1 } from '@src/elements/typography/typography'
import { Spacer } from '@src/elements/spacer/spacer'
import { Divider } from '@src/elements/divider/divider'
import { Button } from '@src/elements/button/button'

import '../../support.sass'

@Component({
  computed: {
    locale () {
      return this.$store.state.i18n.locale || 'en-gb'
    }
  }
})
export class Contact extends Vue {

  private locale: string

  updated () {
    document.title = `${this.$root.$t('PIXFORMANCE_PLATFORM')} - ${this.$root.$t('SUPPORT.SECTION')}`
  }

  render (h: CreateElement) {

    return <div class='support-wrapper'>
      <div class='info-wrapper'>
        <Subtitle1 class='intro-paragraph'>{this.$t('SUPPORT_PAGE.FAQ_INTRO')}</Subtitle1>
        <Caption class='feedback-paragraph'>{this.$t('SUPPORT_PAGE.FAQ_TEXT')}</Caption>

        <Spacer />

        <Button type='elevated' label={this.$t('SUPPORT_PAGE.GO_TO_FAQ')} click={this.goToFAQ} ref='goToFAQ' />

        <Spacer />
        <Divider />
        <Spacer />

        <Subtitle1 class='intro-paragraph'>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET_INTRO')}</Subtitle1>
        <Caption class='feedback-paragraph'>{this.$t('SUPPORT_PAGE.SUPPORT_TICKET_TEXT')}</Caption>

        <Spacer />

        <Button type='elevated' label={this.$t('SUPPORT_PAGE.SUBMIT_REQUEST')} click={this.goToSupport} ref='goToSupport' />
      </div>
    </div>
  }

  goToFAQ () {
    if (this.locale.includes('de')) {
      window.open('https://support.pixformance.com/portal/kb', '_blank')
    } else {
      window.open('https://en.support.pixformance.com/portal/kb', '_blank')
    }
  }

  goToSupport () {
    this.$router.push('/trainers/platform/support/contact-support')
  }
}
